export async function getImageDimensions(imageUrl: string) {
  const img = new Image();
  img.src = imageUrl;
  await img.decode();
  return {
    width: img.width,
    height: img.height,
    orientation: img.width > img.height ? 'landscape' : 'portrait',
  };
}

export async function changeImageOrientation(imageUrl: string) {
  const img = new Image();
  img.src = imageUrl;
  await img.decode();
  const canvas = document.createElement('canvas');
  canvas.width = img.height;
  canvas.height = img.width;
  const ctx = canvas.getContext('2d');
  ctx!.translate(canvas.width / 2, canvas.height / 2);
  ctx!.rotate((90 * Math.PI) / 180);
  ctx!.drawImage(img, -img.width / 2, -img.height / 2);
  return canvas.toDataURL();
}
